import Icon from '@components/common/Icon';
import {classList} from '@containers/Reorder';
import pathOr from 'ramda/src/pathOr';
import {toCurrency} from '@util/NumberUtil';
import {MediumDevice, SmallDevice} from '@ultradent/components'
import AddCartButton from '@components/common/AddCartButton';

export default ( props ) => {
    const {sku, url, productName, kitName, images, customerPrice, catalogPrice} = props.product;
    const price = customerPrice || catalogPrice;
    const displayPrice = toCurrency( parseFloat( price ) );
    const imageSrc = pathOr( '/', [0, 'source'], images );

    return (
        <article className={`${classList.card.root}`}>
            <div className={classList.card.inner}>
                <div className={classList.card.thumbnail}>
                    <img
                        className="lazyload fade-up"
                        data-src={`${imageSrc}?w=512`}
                        alt={kitName}/>
                </div>
                <div className={classList.card.info}>
                    <hr className={classList.rule}/>
                    <h3 className={classList.card.title}>{productName}</h3>
                    <p className={classList.card.subtitle}>{kitName}</p>
                    <p className={classList.card.sku}>#{sku}</p>
                    <p className={`hidden md:block ${classList.card.price}`}>${displayPrice}</p>
                </div>
                <a className={classList.card.dummyAnchor} href={url}></a>
                <MediumDevice>
                    <AddCartButton className={classList.card.addButtonLS} product={props.product}/>
                </MediumDevice>
                <SmallDevice>
                    <a className={classList.card.addButtonSS} data-quick-view data-sku={sku}>
                        <Icon.ui name="shopping-cart-add" className="text-xl mr-2"/>
                        <p className={classList.card.price}>${displayPrice}</p>
                    </a>
                </SmallDevice>
            </div>
        </article>
    );
}
